import { getWhoAmI } from '../../infrastructure/api-signup'
import { useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { useRef } from 'react'

export const useWhoAmI = ({ email, onError }: Options) => {
    const navigate = useNavigate()
    const captchaTokenRef = useRef<string>()
    const queryKey = ['Who am I', email]

    const { data: iAm, ...rest } = useQuery({
        queryKey,
        queryFn: async () => {
            try {
                const captcha_token = captchaTokenRef.current
                captchaTokenRef.current = undefined
                if (!captcha_token) throw new Error('Captcha token not available')
                const whoIAm = await getWhoAmI({ email: `${email}`, captcha_token })
                navigate(whoIAm.goTo)
                return whoIAm
            } catch (error: unknown) {
                onError?.(error)
                throw error
            }
        },
        enabled: false,
        retry: false,
    })

    return { iAm, captchaTokenRef, ...rest }
}

// Interfaces
type Options = {
    email: string
    onError?: (error: unknown) => void
}
